// Central rules for every "Choose File" input in the app.
// Only these extensions may be selected/uploaded.
export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'zip'];

// Value for the <input accept="..."> attribute
export const ALLOWED_FILE_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.zip';

export const ALLOWED_FILE_MESSAGE =
  'Only .pdf, .doc, .docx, .xls, .xlsx, .csv and .zip files are allowed';

export const isAllowedFile = (file) => {
  if (!file || typeof file.name !== 'string') return false;
  const parts = file.name.split('.');
  if (parts.length < 2) return false;
  return ALLOWED_FILE_EXTENSIONS.includes(parts.pop().toLowerCase());
};

// Wraps an input's onChange. If any selected file is not an allowed type
// (e.g. picked through the "All Files" option of the dialog), the selection
// is cleared and the original handler is NOT called.
export const guardAllowedFiles = (handler) => (event, ...rest) => {
  const input = event && event.target;
  const files = input && input.files ? Array.from(input.files) : [];
  if (files.some((f) => !isAllowedFile(f))) {
    alert(ALLOWED_FILE_MESSAGE);
    input.value = '';
    return;
  }
  return handler ? handler(event, ...rest) : undefined;
};
